module.exports = __webpack_public_path__ + "static/media/logo.e5cd3f68.jpg";